exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-select-biz-component-box .left[data-v-7cddf3ce] {\n  width: calc(100% - 82px - 8px);\n}\n.j-select-biz-component-box .right[data-v-7cddf3ce] {\n  width: 82px;\n}\n.j-select-biz-component-box .full[data-v-7cddf3ce] {\n  width: 100%;\n}\n.j-select-biz-component-box[data-v-7cddf3ce] .ant-select-search__field {\n  display: none !important;\n}\n", ""]);

// exports
